import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadUser = useCallback(async () => {
    const token = localStorage.getItem('brazyy_token');
    if (!token) { setLoading(false); return; }
    try {
      const res = await authAPI.getMe();
      setUser(res.data);
    } catch {
      localStorage.removeItem('brazyy_token');
      localStorage.removeItem('brazyy_user');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Check for token in URL (from OAuth callback)
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (token) {
      localStorage.setItem('brazyy_token', token);
      window.history.replaceState({}, '', window.location.pathname);
    }
    loadUser();
  }, [loadUser]);

  const logout = () => {
    localStorage.removeItem('brazyy_token');
    localStorage.removeItem('brazyy_user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, logout, loadUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
